import { render, staticRenderFns } from "./ed-deck-library-sections.component.vue?vue&type=template&id=548644ea&scoped=true&"
import script from "./ed-deck-library-sections.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-library-sections.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-library-sections.component.scss?vue&type=style&index=0&id=548644ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548644ea",
  null
  
)

export default component.exports